var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLedgerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6248 7H19.9365V27.9862H40.9914V12.4602C41 9.51219 38.5825 7 35.6248 7ZM15.1185 7H12.4866C9.529 7 7 9.40111 7 12.4687V15.092H15.1185V7ZM7 20.0053H15.1185V28.0973H7V20.0053ZM32.8815 40.9915H35.5134C38.471 40.9915 41 38.5903 41 35.5227V32.908H32.8815V40.9915ZM19.9365 32.908H28.055V41H19.9365V32.908ZM7 32.908V35.5313C7 38.4793 9.40898 41 12.4866 41H15.1185V32.908H7Z",
    fill: "#9597A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerLogo);
export default __webpack_public_path__ + "static/media/ledgerLogo.4d44bd94.svg";
export { ForwardRef as ReactComponent };